<script lang="ts">
	import type { LoadResult } from '@kestrel/server';
	import type { load } from './ServicePageTeaserServer.ts';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import ToSignUp from '../../../components/teaser/large/ToSignUp.svelte';
	import ToLogin from '../../../components/teaser/large/ToLogin.svelte';
	import ToUpHome from '../../../components/teaser/large/ToUpHome.svelte';
	import { clientLoggerScope } from '../../../clientLogger.ts';
	import { onMount } from 'svelte';

	let { data }: { data: LoadResult<typeof load> } = $props();

	if (!import.meta.env.SSR) {
		const log = clientLoggerScope.scope('ServicePageTeaser.SSR.false');
		log.trace('Service Page loaded on client side');
	}


	onMount(()=>{
		const log = clientLoggerScope.scope('ServicePageTeaser');
		log.trace('Service Page mounted');
	});
	const teaserSize = 'MediaObject100';

	const showSignUp = data.teaserType === TeaserType.BASIC_AND_PLUS_TEASER;
	const showToLogin = data.teaserType === TeaserType.TO_LOGIN;
	const showToUpHome = data.teaserType === TeaserType.TO_UP_HOME;
</script>

{#if !data.disableServicePageTeaser}
	{#if showSignUp && data.teaserContent}
		<ToSignUp
			teaserContent={data.teaserContent}
			teaserType={data.teaserType}
			teaserSize={teaserSize}
			teaserTouchPoint={data.teaserTouchPoint}
			newProgramStructureDesign={data.newProgramStructureDesign}
		/>
	{:else if showToLogin && data.teaserContent}
		<ToLogin
			teaserContent={data.teaserContent}
			teaserSize={teaserSize}
		/>
	{:else if showToUpHome && data.teaserContent}
		<ToUpHome
			teaserContent={data.teaserContent}
		/>
	{:else}
		<div data-testid="no-content-teaser-container" data-tracking-teaser-no-content-reason={data.noContentReason}></div>
	{/if}
{/if}
